define.alias("shared/components/shared/choose-your-upgrade/plan-card", "calendar/components/shared/choose-your-upgrade/plan-card");